// eslint-disable-next-line
import React, { Component } from "react";
import { Col, Container, Row } from 'reactstrap';
import { withRouter, } from "react-router-dom";
import ModalsVentasPage from "./modals.ventas.page";
import MakeViewAlmacenGral from "./MakeViewAlmacenGral";
import Select from 'react-select'
import moment from 'moment'
import { faPlus,faEye,faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import TimeAgo from 'react-timeago'
import spanishStrings from 'react-timeago/lib/language-strings/es'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'

const customStylesOption = { control: styles => ({ ...styles, backgroundColor: '#fff', width: '90%', margin: '0 auto', marginBottom: 20, }), }
const customStyles = { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '70%',height: '70%',} };
const formatter = buildFormatter(spanishStrings)


class AltasModulePage extends Component {
  constructor(props) {
    super(props);

    this.state = {

      flagNewProceso: false,
      arrNewProceso: {
        identificador: '',
        kg: 0,
        observacion: '',
      },

      indexTraspasoView: -1,
      indexConfirmadosView: -1,
      dateTraspasosConfirmados: moment().format('YYYY-MM-DD'),
    }
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  setDeleteTraspaso(item) {
    const { id_entrada, } = item;

    if (window.confirm(`¿Estás seguro que deseas eliminar este traspaso?`)) {
      fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=setDeleteTraspaso", this.headersPOST({ id_entrada }))
      .then(response => response.json())
      .then((response) => {
        alert('Traspaso eliminado con éxito')
        this.getCombosAlmacenGral()
      })
    }

  }

  render() {
    const { arrAlmacenGral, indexItemByCombo, arrTraspasosPendientes, arrTraspasosConfirmados, } = this.props.subState
    const { mostrarMisVentas, } = this.props.altasState
    const { indexTraspasoView, indexConfirmadosView, } = this.state

    if(mostrarMisVentas === 3) {
      //Vista combos de almacen
      return (
        <div className="initialPage__wrapper"  style={{ backgroundColor: 'transparent', width: '100%', }} className={'z-depth-1'}>
          <Row style={{ width: '99%', margin: '0 auto' }}>
            <Col style={{ background: '#fff', }}>
              <Row>
                <p className="regVentaPage__product" style={{ padding: '0 15px', fontWeight: '400', marginBottom: 10, color: '#444', textAlign: 'left', width: '100%', }}>Almacen general</p>
              </Row>
              { indexItemByCombo === -1
                ? this.makeListCombos()
                : this.makeInfoCombo()
              }

              <hr />
            </Col>
          </Row>

          <Row style={{ width: '99%', margin: '0 auto' }}>
            <Col style={{ background: '#fff', }}>
              <Row>
                <p className="regVentaPage__product" style={{ padding: '0 15px', fontWeight: '400', marginBottom: 10, color: '#444', textAlign: 'left', width: '100%', }}>Envíos pendientes</p>
              </Row>
              <div className="table-responsive">
                <table className="table table-sm" style={{minWidth:'1200px'}}>
                  <thead>
                    <tr>
                      <th>Sucursal destino</th>
                      <th>Fechas</th>
                      <th>Cantidades</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      arrTraspasosPendientes.map((t,e) => (
             
                        <tr className="ws__list_identificador" onClick={() => { this.onExpandInfoTraspasoProducto(e) }}>
                          <td>
                            <p>{t.sucursal}</p>
                          </td>
                          <td>
                            <p>{moment(t.created_at).format('DD/MM/YYYY HH:mm:ss')}</p>
                            <TimeAgo
                              style={{ color: '#444', }}
                              className="__listViewPending_time" date={t.created_at} formatter={formatter}
                            />
                          </td>
                          <td>
                            <p>Total productos: {(t.count_productos)}</p>
                            <p>KG enviados: {this.number_format(t.cantidad_envio,2)}</p>
                          </td>
                          <td>
                            {
                              t.arrListProductos.length > 0 ? (
                                <p>Total: ${this.number_format(( this.makeTotalPCompraProductos(t) ),2)}</p>
                              ) : (<p>.</p>)
                            }
                            <p style={{ cursor: 'pointer', }} onClick={() => { this.setDeleteTraspaso(t) }}>Eliminar</p>
                          </td>
                        </tr>
                      ))
                    }

                  </tbody>
                </table>
              </div>
              {
                indexTraspasoView > -1 ? (
                  <div className="table-responsive">
                    <table className="table table-sm" style={{minWidth:'1200px'}}>
                      <thead>
                        <tr>
                          <th>Nombre producto</th>
                          <th>KG enviados</th>
                          <th>Total compra</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          arrTraspasosPendientes[indexTraspasoView].arrListProductos.map((t,e) => (
                            <tr className="ws__list_identificador">
                              <p>{t.nombre}</p>
                              <td>{this.number_format(t.cantidad, 2)}</td>
                              <td>${this.number_format(parseFloat(t.cantidad) * parseFloat(t.precio_compra), 2)}</td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                  </div>
                ) : null
              }

            </Col>
          </Row>

          <Row style={{ width: '99%', margin: '0 auto' }}>
            <Col style={{ background: '#fff', }}>
              <Row>
                <Col>
                  <p className="regVentaPage__product" style={{ padding: '0 15px', fontWeight: '800', marginBottom: 10, color: '#444', textAlign: 'left', width: '100%', }}>Envíos confirmados/merma</p>
                </Col>
                <Col>
                  <Row>
                    <Col>
                      <input
                        type={'date'}
                        value={ this.state.dateTraspasosConfirmados }
                        onChange={(e) => { this.setState({ dateTraspasosConfirmados: e.target.value }) }}
                        className={'regVentaPage__input_date'}
                      />
                    </Col>
                    <Col>
                      <p className={'btn btn-primary'} onClick={() => { this.getCombosAlmacenGral() }}>Generar</p>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <div className="table-responsive">
                <table className="table table-sm" style={{minWidth:'1200px'}}>
                  <thead>
                    <tr>
                      <th>Sucursal destino</th>
                      <th>Fechas</th>
                      <th>Cantidades</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      indexConfirmadosView === -1 && arrTraspasosConfirmados.map((t,e) => (
             
                        <tr className="ws__list_identificador" onClick={() => { this.onExpandInfoConfirmadosProductos(e) }}>
                          <td>
                            <p>{t.sucursal}</p>
                          </td>
                          <td>
                            <p>Envío: {moment(t.created_at).format('DD/MM/YYYY HH:mm:ss')}</p>
                            <p>Recibido: {moment(t.date_recibido).format('DD/MM/YYYY HH:mm:ss')}</p>
                          </td>
                          <td>
                            <p>Total productos: {(t.count_productos)}</p>
                            <p>KG enviados: {this.number_format(t.cantidad_envio,2)}</p>
                            <p>KG confirmados: {this.number_format(t.cantidad_recibido,2)}</p>
                            <p style={{ color: `${ parseFloat(t.cantidad_merma) > 0 ? 'red' : '#000'}` }}>KG merma: {this.number_format(t.cantidad_merma,2)}</p>
                          </td>
                          <td></td>
                        </tr>
                      ))
                    }

                  </tbody>
                </table>
              </div>
              {
                indexConfirmadosView > -1 ? (
                  <div className="table-responsive">
                    <button className={'btn btn-secondary'} onClick={() => { this.setState({ indexConfirmadosView: -1, }) }}>Regresar</button>
                    <br />
                    <b>Sucursal: {arrTraspasosConfirmados[indexConfirmadosView].sucursal}</b>
                    <Row>
                      <Col>
                        <p>Enviado: ${this.number_format(( this.makeTotalPCompraByOPT(arrTraspasosConfirmados[indexConfirmadosView], 1) ),2)}</p>
                      </Col>
                      <Col>
                        <p>Confirmado: ${this.number_format(( this.makeTotalPCompraByOPT(arrTraspasosConfirmados[indexConfirmadosView], 2) ),2)}</p>
                      </Col>
                      <Col>
                        <p>Merma: ${this.number_format(( this.makeTotalPCompraByOPT(arrTraspasosConfirmados[indexConfirmadosView], 3) ),2)}</p>
                      </Col>
                    </Row>
                    <table className="table table-sm" style={{minWidth:'1200px'}}>
                      <thead>
                        <tr>
                          <th>Nombre producto</th>
                          <th>Enviado</th>
                          <th>Confirmados de recepción</th>
                          <th>Merma</th>
                          <th>Observación</th>
                          <th>Opciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          arrTraspasosConfirmados[indexConfirmadosView].arrListProductos.map((t,e) => (
                            <tr className="ws__list_identificador">
                              <p>{t.nombre}</p>
                              <td>
                                <p>KG: {this.number_format(t.cantidad, 2)}</p>
                                <p>Total: ${this.number_format(parseFloat(t.cantidad) * parseFloat(t.precio_compra), 2)}</p>
                              </td>
                              <td>
                                <p>KG: {this.number_format(t.cantidad_recibido, 2)}</p>
                                <p>Total: ${this.number_format(parseFloat(t.cantidad_recibido) * parseFloat(t.precio_compra), 2)}</p>
                              </td>
                              <td>
                                <p style={{ color: `${ parseFloat(t.cantidad_merma) > 0 ? 'red' : '#000'}` }}>KG: {this.number_format(t.cantidad_merma, 2)}</p>
                                <p style={{ color: `${ parseFloat(t.cantidad_merma) > 0 ? 'red' : '#000'}` }}>Total: ${this.number_format(parseFloat(t.cantidad_merma) * parseFloat(t.precio_compra), 2)}</p>
                              </td>
                              <td>{t.observacion}</td>
                              <td>
                                <button className={' btn btn-secondary '}>Autorizar</button>
                                <button className={' btn btn-danger '}>Reportar</button>
                              </td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                  </div>
                ) : null
              }
              
            </Col>
          </Row>
        </div>
      )
    } else if(mostrarMisVentas === 4) {
      //Vista productos en almacen
      return <>{this.makeProductosAlmacenView()}</>
    } else { return null }
  }

  makeTotalPCompraProductos(t) {
    let totalPCompra = 0
    t.arrListProductos.map((t0) => {
      totalPCompra += (parseFloat(t0.precio_compra) * parseFloat(t0.cantidad))
    })
    return totalPCompra
  }

  makeTotalPCompraByOPT(t, opt) {
    let totalPCompra = 0, sum = 0
    t.arrListProductos.map((t0) => {
      if(opt == 1) sum = (parseFloat(t0.precio_compra) * parseFloat(t0.cantidad))
      else if(opt === 2) sum = (parseFloat(t0.precio_compra) * parseFloat(t0.cantidad_recibido))
      else if(opt === 3) sum = (parseFloat(t0.precio_compra) * parseFloat(t0.cantidad_merma))

      totalPCompra += sum
    })
    return totalPCompra
  }

  onExpandInfoTraspasoProducto(e) {
    if(this.state.indexTraspasoView === e) {
      this.setState({ indexTraspasoView: -1, })
      return false
    }
    let { arrTraspasosPendientes, } = this.props.subState
    this.setState({ indexTraspasoView: e, })


    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getProductosByTraspasoGral", this.headersPOST({ id_entrada: arrTraspasosPendientes[e].id_entrada }))
    .then(response => response.json())
    .then((response) => {
      arrTraspasosPendientes[e].arrListProductos = response.list
      this.props.subSetState({ arrTraspasosPendientes })
    })
  }

  onExpandInfoConfirmadosProductos(e) {
    if(this.state.indexConfirmadosView === e) {
      this.setState({ indexConfirmadosView: -1, })
      return false
    }
    let { arrTraspasosConfirmados, } = this.props.subState
    this.setState({ indexConfirmadosView: e, })


    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getProductosByTraspasoGral", this.headersPOST({ id_entrada: arrTraspasosConfirmados[e].id_entrada }))
    .then(response => response.json())
    .then((response) => {
      arrTraspasosConfirmados[e].arrListProductos = response.list
      this.props.subSetState({ arrTraspasosConfirmados })
    })
  }

  makeListCombos() {
    const { indexItemByCombo, arrAlmacenGral, } = this.props.subState

    return (
      <>
        <div className="form-check form-check-inline">
          <p
            className={'btn btn-sm altasModule__btnAction'}
            onClick={() =>{ this.props.subSetState({ isOpenAltaAlmacenGral: true, }) }}
          ><FontAwesomeIcon icon={faPlus} /> Nueva entrada almacen gral.</p>
        </div>
        <div className="table-responsive">
        <table className="table table-sm" style={{minWidth:'1200px'}}>
          <thead>
            <tr>
              <th>Identificador</th>
              <th>Proveedor</th>
              <th>KG Ticket</th>
              <th>KG recibidos reales</th>
              <th>Total pagado</th>
              <th>Total $ perdidos</th>
              <th>Merma en KG</th>
              <th>Merma en $</th>
              <th>KG Procesados</th>
              <th>Disponible KG</th>
            </tr>
          </thead>
          <tbody>
            
        {
          arrAlmacenGral.length > 0 && arrAlmacenGral.map((t,e) => (
 
            <tr className="ws__list_identificador" onClick={() => { this.expandInfoAlmacenGral(e) }}>
              <td>{t.identificador}</td>
              <td>{(t.proveedor)}</td>
              <td>{ this.number_format(( (t.kg_ticket) ), 2)} KG</td>
              <td>{ this.number_format(( t.kg_recibido_real ), 2)} KG</td>
              <td>${ this.number_format(( t.total_pagado ), 2)}</td>
              <td>{ this.number_format(( t.total_perdidos ), 2)}</td>
              <td>{ this.number_format(( t.merma_kg ), 2)} KG</td>
              <td>${ this.number_format(( t.merma_pesos ), 2)}</td>
              <td>{ this.number_format(( t.procesados_productos_kg ), 2)}</td>
              <td>{ this.number_format(( t.kg_ticket - (t.procesos_kg + t.merma_kg) ), 2)}</td>
            </tr>

            // <Row style={{ marginTop: 20, marginBottom: 20, }} className={'ws__list_identificador'} onClick={() => { this.expandInfoAlmacenGral(e) }}>
            //   <Col><p>{t.identificador}</p></Col>
            //   <Col><p>{(t.proveedor)}</p></Col>
            //   <Col><p>{ this.number_format(( (t.kg_ticket) ), 2)} KG</p></Col>
            //   <Col><p>{ this.number_format(( t.kg_recibido_real ), 2)} KG</p></Col>
            //   <Col><p>${ this.number_format(( t.total_pagado ), 2)}</p></Col>
            //   <Col><p>{ this.number_format(( t.total_perdidos ), 2)}</p></Col>
            //   <Col><p>{ this.number_format(( t.merma_kg ), 2)} KG</p></Col>
            //   <Col><p>${ this.number_format(( t.merma_pesos ), 2)}</p></Col>
            //   <Col><p>{ this.number_format(( t.total  ), 2)}</p></Col>
            //   <Col><p>{ this.number_format(( t.kg_recibido_real - (t.total + t.merma_kg) ), 2)}</p></Col>
            // </Row>
          ))
        }
          </tbody>
        </table>
        </div>
      </>
    )
  }

  makeInfoCombo() {
    const { indexItemByCombo, arrAlmacenGral, arrProcesos, } = this.props.subState
    const { flagNewProceso, arrNewProceso, } = this.state
    const t = arrAlmacenGral[indexItemByCombo]

    console.log('into', t)

    if(indexItemByCombo === -1)
      return null
    
    return (
      <>
        <button className={'btn btn-secondary'} onClick={() => { this.props.subSetState({ indexItemByCombo: -1 }) }}><FontAwesomeIcon icon={faArrowLeft} /> Atrás</button>
        <div className="table-responsive" style={{marginTop:10}}>
        <table className="table table-sm" style={{minWidth:'1200px'}}>
          <thead>
            <tr>
              <th>Identificador</th>
              <th>Proveedor</th>
              <th>KG Ticket</th>
              <th>KG recibidos reales</th>
              <th>Total pagado</th>
              <th>Total $ perdidos</th>
              <th>Merma en KG</th>
              <th>Merma en $</th>
              <th>KG Procesados</th>
              <th>Disponible KG</th>
            </tr>
          </thead>
          <tbody>
            <tr className="ws__list_identificador">
              <td>{t.identificador}</td>
              <td>{(t.proveedor)}</td>
              <td>{ this.number_format(( (t.kg_ticket) ), 2)} KG</td>
              <td>{ this.number_format(( t.kg_recibido_real ), 2)} KG</td>
              <td>${ this.number_format(( t.total_pagado ), 2)}</td>
              <td>{ this.number_format(( t.total_perdidos ), 2)}</td>
              <td>{ this.number_format(( t.merma_kg ), 2)} KG</td>
              <td>${ this.number_format(( t.merma_pesos ), 2)}</td>
              <td>{ this.number_format(( t.procesados_productos_kg ), 2)}</td>
              <td>{ this.number_format(( t.kg_ticket - (t.procesos_kg + t.merma_kg) ), 2)}</td>
            </tr>
          </tbody>
        </table>
        </div>

        {/* <Row style={{ marginTop: 20, marginBottom: 20, }}>
          <Col><p>{t.identificador}</p></Col>
          <Col><p>{(t.proveedor)}</p></Col>
          <Col><p>{ this.number_format(( (t.kg_ticket) ), 2)} KG</p></Col>
          <Col><p>{ this.number_format(( t.kg_recibido_real ), 2)} KG</p></Col>
          <Col><p>${ this.number_format(( t.total_pagado ), 2)}</p></Col>
          <Col><p>{ this.number_format(( t.total_perdidos ), 2)}</p></Col>
          <Col><p>{ this.number_format(( t.merma_kg ), 2)} KG</p></Col>
          <Col><p>${ this.number_format(( t.merma_pesos ), 2)}</p></Col>
          <Col><p>{ this.number_format(( t.total  ), 2)}</p></Col>
          <Col><p>{ this.number_format(( t.kg_recibido_real - (t.total + t.merma_kg) ), 2)}</p></Col>
        </Row> */}

        <hr />
        <Row>
          <Col><h5>Procesos primarios</h5></Col>
          <Col>
            { !flagNewProceso
              ? <button className={'btn btn-primary'} onClick={ () => { this.setState({ flagNewProceso: true, }) }}><FontAwesomeIcon icon={faPlus} /> Nuevo proceso</button>
              : <button className={'btn btn-secondary'} onClick={ () => { this.setState({ flagNewProceso: false, }) }}>Ver procesos</button>
            }
          </Col>
        </Row>
        <hr />

          {
            !flagNewProceso ? (
              <>
                {/* Mostrar listado de procesos */}
                <div className="table-responsive">
                <table className="table table-sm" style={{minWidth:'1200px'}}>
                  <thead>
                    <tr>
                      <th>Identificador</th>
                      <th>KG registrados</th>
                      <th>KG procesados</th>
                      <th>KG sin procesar</th>
                      <th>KG merma</th>
                      <th>Opciones</th>
                    </tr>
                  </thead>
                  <tbody>
                  {
                    arrProcesos.map((t,e) => (
                      <tr className={'ws__list_identificador'}>
                        <td>
                        <p className={'proceso_identificador'}>{t.identificador}</p>
                          { t.status !== 1 ? ( <p className={'badge badgeEnd'} style={{ fontSize: '.8rem', }}>Finalizado</p> ) : null }
                        </td>
                        <td><p>{ this.number_format(( t.kg ), 2)} KG</p></td>
                        <td><p>{ this.number_format(( t.kg_procesado ), 2)} KG</p></td>
                        <td><p>{ this.number_format(( t.kg_sin_procesar ), 2)} KG</p></td>
                        <td>
                          <p>
                            {
                            /* Realmente los kg sin procesar al terminar el proceso ya es merma. */
                            t.status === 1 ? 'Sin procesar' : `${this.number_format(( t.kg_sin_procesar ), 2)} KG`
                            }
                          </p>
                        </td>
                        <td>
                          {
                            t.status === 1 ? (
                              <>
                                <button className={'btn btn-primary'} onClick={() => { this.setBindProductoByProceso(e) }}>Registrar productos</button>
                                <button className={'btn btn-primary'} onClick={() => { this.setViewProductoByProceso(e) }}><FontAwesomeIcon icon={faEye} /> Ver registros</button>
                                <button className={'btn btn-danger'} onClick={() => { this.setEndProductoByProceso(e) }}>Concluir proceso</button>
                              </>
                            ) : (
                              <button className={'btn btn-primary'} onClick={() => { this.setViewProductoByProceso(e) }}><FontAwesomeIcon icon={faEye} /> Ver registros</button>
                            )
                          }
                        </td>
                      </tr>
                    ))
                    
                  }
                </tbody>
              </table>
              </div>

              </>
            ) : (
              <>
                {/* Mostrar nuevo proceso */}
                <h5 style={{ textAlign: 'center', }}>Registrar proceso</h5>
                <div className={'modalsVentas__formAddProducto'}>
                  <p>Identificador</p>
                  <input type={'text'}
                    placeholder={'Ingresa un identificador'}
                    onChange={(event) => {
                      arrNewProceso.identificador = event.target.value
                      this.setState({ arrNewProceso, })
                    }}
                    value={arrNewProceso.identificador}
                  />
                </div>

                <div className={'modalsVentas__formAddProducto'}>
                  <p>Cantidad (KG)</p>
                  <input type={'number'}
                    placeholder={''}
                    onChange={(event) => {
                      arrNewProceso.kg = event.target.value
                      this.setState({ arrNewProceso, })
                    }}
                    value={arrNewProceso.kg}
                  />
                </div>

                <textarea
                  value={arrNewProceso.observacion}
                  placeholder={'Ingresa alguna descripción aquí.'}
                  onChange={(event) => {
                    arrNewProceso.observacion = event.target.value
                    this.setState({ arrNewProceso, })
                  }}
                  style={{ border: '1px solid #f3f3f3', background: '#f3f3f3', borderRadius: 4, minHeight: 200, resize: 'none', width: '90%', margin: '0 auto', display: 'block', }}
                ></textarea>

                <div style={{ textAlign: 'center', }}>
                  <button
                    className={'btn btn-primary modalsVentas__btnAddProducto'}
                    onClick={() => { this.onAddNuevoProceso() }}
                  >Registrar proceso primario</button>
                </div>
              </>
            )
          }


        <hr />

      </>
    )
  }

  expandInfoAlmacenGral(e) {
    const { arrAlmacenGral, } = this.props.subState
    this.props.subSetState({ indexItemByCombo: e, })
    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getInfoByCombo", this.headersPOST({ id_combo: arrAlmacenGral[e].id_combo }))
    .then(response => response.json())
    .then((response) => {
      this.props.subSetState({ arrProcesos: response.procesos, })
    })
  }

  onAddNuevoProceso() {
    const { arrNewProceso } = this.state
    const { identificador, kg, observacion, } = arrNewProceso
    const { arrAlmacenGral, indexItemByCombo, } = this.props.subState

    //Validar
    if(
      identificador.trim() == '' ||
      kg.trim() == '' 
      ) {
      alert('Por favor, rellena los campos del formulario.');
      return false
    }


    //Registrar en BD
    const data = {
      ...arrNewProceso,
      id_sucursal: this.props.initState.id_sucursal,
      id_usuario: this.props.initState.id_usuario,
      id_combo: arrAlmacenGral[indexItemByCombo].id_combo,
    }

    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=setRegisterProcesoByCombo", this.headersPOST({...data}))
    .then(response => response.json())
    .then((response) => {

      this.setState({
        arrNewProceso: {
          identificador: '',
          kg: '',
          observacion: 0,
        },
        flagNewProceso: false,
      })

      this.props.subSetState({ indexItemByCombo: -1 })

      setTimeout(() => {
        this.expandInfoAlmacenGral(indexItemByCombo)
      }, 1000)

      alert("Proceso primario registrado con éxito")
    })
  }


  setBindProductoByProceso(e) {
    this.props.subSetState({ isOpenNewProductoByProceso: true, arrItemsAlmacen: [], indexItemByProceso: e, })
  }

  setViewProductoByProceso(e) {
    this.props.subSetState({ isOpenViewProductoByProceso: true, indexItemByProceso: e, optViewProdByProc: 1, })
  }

  setEndProductoByProceso(e) {
    this.props.subSetState({ isOpenEndProductoByProceso: true, indexItemByProceso: e, })
  }

  /*** VISTA ALMACEN PRODUCTOS ***/

  makeProductosAlmacenView() {
    let { arrStockGral, valSeach, } = this.props.altasState
    valSeach = valSeach.trim()

    return (
      <div className="initialPage__wrapper"  style={{ backgroundColor: 'transparent', }}>
        {/* Principal Container */}
        <Row style={{ width: '99%', margin: '0 auto' }}>
          <Col className={'z-depth-1'} style={{ background: '#fff', }}>
            
            <Row>
              <p className="regVentaPage__product" style={{ padding: '0 15px', fontWeight: '400', margin: 10, color: '#444', textAlign: 'center', width: '100%', }}>Almacen general</p>
            </Row>

            <hr />
            <Row>
              <Col>
                <Row>
                  <Col>
                    <input
                      type={'date'}
                      value={ this.state.dateAlmacen }
                      onChange={(e) => { this.setState({ dateAlmacen: e.target.value }) }}
                      className={'regVentaPage__input_date'}
                    />
                  </Col>
                  <Col>
                    <p className={'btn btn-primary'} onClick={() => { this.getStockAlmacenGral() }}>Generar</p>
                  </Col>
                </Row>
              </Col>
            </Row>

            <hr />

            {
              arrStockGral.map((t,e) => (
                <>
                {
                  t.list.length > 0 ? (
                    <div className={'ws__list_categorias_almacen'}>
                      <Row className={`ws__list_categorias_almacen_p ${t.show ? 'active' : ''}`} onClick={() => { this.onExpandSectionCate(t,e) }}>
                        <Col>
                          <p>{t.nombre}</p>
                        </Col>
                        <Col>
                          <p style={{ fontSize: '.8rem', textAlign: 'right', }}>({this.number_format(t.list.length, 0)}) productos</p>
                        </Col>
                      </Row>

                      {
                        t.show ? (
                          <div className={'ws__searchcnt'}>
                            <p>Buscar</p>
                            <input
                              type={'text'}
                              onChange={ (event) => { this.setState({ valSeach: event.target.value }) } }
                              placeholder={'Buscar un producto...'}
                            />
                          </div>
                        ) : null
                      }
                      {
                        t.show ? (
                        <Row>
                          <Col xs={'4'}>
                            <b>Nombre</b>
                          </Col>
                          <Col xs={'2'}>
                            <b>Existencia</b>
                          </Col>
                          <Col xs={'1'}>
                            <b>Entrada del día</b>
                          </Col>
                          <Col xs={'2'}>
                            <b>Traspaso pendiente</b>
                          </Col>
                          <Col xs={'2'}>
                            <b>Traspaso recibido</b>
                          </Col>
                          <Col xs={'1'}>
                            <b>Merma</b>
                          </Col>
                        </Row>
                        ) : null
                      }

                      {
                        t.show && t.list.map((t0,e0) => (
                          <>
                          {
                            valSeach === '' || 
                            t0.clave.toLowerCase().indexOf(valSeach.toLowerCase()) !== -1 ||
                            t0.nombre.trim().toLowerCase().indexOf(valSeach.toLowerCase()) !== -1 ? (
                            <Row className={'ventasPage__listProductos ws__list_categorias_almacen_child'} style={{ marginTop: 20, marginBottom: 20, }}>
                              <Col xs={'4'}>
                                <p>{t0.nombre}</p>
                                <p>{t0.clave}</p>
                              </Col>
                              <Col xs={'2'}>
                                <p>{this.number_format(t0.disponible, 2)}</p>
                              </Col>
                              <Col xs={'1'}>
                                <p>{this.number_format(t0.cantidad_dia, 2)}</p>
                              </Col>
                              <Col xs={'2'}>
                                <p>{this.number_format(t0.cantidad_pendiente, 2)}</p>
                              </Col>
                              <Col xs={'2'}>
                                <p>{this.number_format(t0.cantidad_traspaso, 2)}</p>
                              </Col>
                              <Col xs={'1'}>
                                <p>{this.number_format(t0.cantidad_merma, 2)}</p>
                              </Col>
                            </Row>
                            ) : null
                          }
                          </>
                        ))
                      }

                    </div>
                  ) : null
                }
                </>
              ))
            }

          </Col>

        </Row>

      </div>

    )
  }

  getStockAlmacenGral() {
    const { dateAlmacen, } = this.props.altasState

    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerPreproduction.php?opt=getStockAlmacenGral", this.headersPOST({ dateAlmacen }))
    .then(response => response.json())
    .then((response) => {
      let arrStockGral = this.onVerifySectionShowCate(response)
      this.props.altassetState({ arrStockGral, })
    })
  }

  getCombosAlmacenGral() {
    const { dateTraspasosConfirmados } = this.state
    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getCombosAlmacenGral", this.headersPOST({ dateTraspasosConfirmados }))
    .then(response => response.json())
    .then((response) => {
      this.props.subSetState({ arrAlmacenGral: response.combos, arrTraspasosPendientes: response.pendientes, arrTraspasosConfirmados: response.confirmados, })
    })
  }
  
  onVerifySectionShowCate(response) {
    let { arrStockGral, } = this.props.altasState
    let index = -1
    for(var a in arrStockGral) {
      if(arrStockGral[a].show) {
        index = a
        break
      }
    }
    
    if(index > -1)
      response[a].show = true
    return response
  }
  
  onExpandSectionCate(t,e) {
    let { arrStockGral, } = this.props.altasState
    for(var a in arrStockGral) {
      if(a != e)
        arrStockGral[a].show = false
      else
      arrStockGral[a].show = !arrStockGral[a].show
    }
    this.props.altassetState({ arrStockGral, valSeach: '', })
  }

  /*** // VISTA ALMACEN PRODUCTOS ***/


  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }

  number_format(number, decimals, decPoint, thousandsSep) {
    number = (number+'').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return ''+(Math.round(n * k) / k)
      .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : ''+Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length+1).join('0')
    }
    return s.join(dec)
  }


}

export default withRouter(AltasModulePage)





